import React from 'react'
import { Outlet } from 'react-router-dom'
import { createTheme, ThemeProvider } from '@mui/material/styles'
import CssBaseline from '@mui/material/CssBaseline'
import Box from '@mui/material/Box'

const mdTheme = createTheme({
  palette: {
    primary: {
      main: '#432B8D'
    },
    secondary: {
      main: '#007FAA'
    },
    warning: {
      main: '#ffdb5e'
    }
  }
})

const AppLayoutPublic = () => {
  return (
    <ThemeProvider theme={mdTheme}>
      <Box sx={{ display: 'flex' }}>
        <CssBaseline />
        <Box
          component='main'
          sx={{
            backgroundColor: (theme) =>
              theme.palette.mode === 'light'
                ? theme.palette.grey[100]
                : theme.palette.grey[900],
            flexGrow: 1,
            height: '100vh',
            overflow: 'auto'
          }}
        >
          <Outlet />
        </Box>
      </Box>
    </ThemeProvider>
  )
}

export default AppLayoutPublic
